import { v4 as generateUUIDV4 } from 'uuid';

export const generateUUID = (): string => generateUUIDV4();
